import { gql } from "@apollo/client";

const CREATE_UPLOAD = gql`
  mutation createUpload(
    $campaignId: ID
    $type: UploadType!
    $visibility: UploadVisibility!
    $contentType: String!
    $fileName: String!
  ) {
    createUpload(
      upload: {
        campaignId: $campaignId
        type: $type
        visibility: $visibility
        contentType: $contentType
        fileName: $fileName
      }
    ) {
      token
      presignedPutURL
    }
  }
`;

export default CREATE_UPLOAD;
